// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
import Draggable from '../../utils/drag';
import $ from 'jquery';
import Modal from '../modal';
import styles from './index.less';
import { iconfont } from '../../utils/utils';

Swiper.use([Navigation, Pagination]);
const defaultPrams = {
  imgList: [],
};
export default class SwiperModal extends Modal {
  constructor(props) {
    super(props);
    this.hotspotId = 100;
    this.params = {
      ...defaultPrams,
      ...props,
    };
    this.dragImg = null;
    this._initContent();
  }
  _initContent() {
    this.$contentWrapper = $(`<div class="pano-swiper-wrapper"></div>`);
    this._addSlider();
    this._addNav();
    this._addControles();
    this.$dom.append(this.$contentWrapper);
    newSwiper();
  }
  _addControles() {
    const $controle = $(`<div class="pano-swiper-controles" style=""></div>`);
    $controle.append(`<div class="controles-btn zoomin_btn" onclick="handleZoomIn()"> ${iconfont('iconfangda', 'fl')} 放大</div>`);
    $controle.append(
      `<div class="controles-btn zoomout_btn" onclick="handleZoomOut()"> ${iconfont('iconsuoxiao', 'fl')}  缩小</div>`,
    );
    $controle.append(`<div class="controles-btn reset_btn" onclick="handleZoomReset()"> ${iconfont('iconxunyou', 'fl')}  重置</div>`);
    this.$contentWrapper.append($controle);
  }
  _addSlider() {
    const $swiperContainer = $(`<div class="pano-swiper-container swiper-container"></>`);
    $swiperContainer.on('click', (e) => {
      if (e.target.className == 'swiper-zoom-container') {
        this.hide();
      }
    });

    // wrapper
    // const swiperWrapper = $(`<div class="${swiperStyle['swiper-wrapper']}"></>`);
    const $swiperWrapper = $(`<div class="swiper-wrapper"></div>`);
    this.params.imgList.forEach(el => {
      $swiperWrapper.append(
        $(
          `<div class="swiper-slide" style="overflow:hidden">

              <div class="swiper-zoom-container">
                <img src="${el.url}?x-oss-process=image/resize,w_3000,h_3000,limit_0">
              </div>

            ${el.text ? `<div class="content-text">${el.text}</div>` : ''}
          </div>`,
        ),
      );
    });
    $swiperContainer.append($swiperWrapper);
    this.$contentWrapper.append($swiperContainer);
  }
  _addNav() {
    // nav
    const $prevNav = $(
      `<div class="swiper-nav prev">
        ${iconfont('iconUC-xiangzuo')} 
      </div>`,
    );
    const $nextNav = $(
      `<div class="swiper-nav next">
        ${iconfont('iconUC-xiangyou')} 
      </div>`,
    );
    this.$pagination = $(
      `<div class="pano-swiper-pagination">
      </div>`,
    );
    if (this.params.imgList.length > 1) {
      this.$dom.append($prevNav);
      this.$dom.append($nextNav);
    }
    
    this.$dom.append(this.$pagination);
  }

  _changePage(index) {
    this.$pagination.html(`${index}/${this.params.imgList.length}`);
  }
}
